import React from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import Form from '@components/Common/Form';
import FormRow from '@components/Common/FormRow';
import FormSection from '@components/Common/FormSection';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

/** 파트너 계정: 조합 관리 > 상세 > 조합 상세 정보 스켈레톤 */
const PartnerDetailInfoSkeleton = () => {
  return (
    <div css={{ marginBottom: '40px' }}>
      <div css={[titleStyle, { justifyContent: 'space-between' }]}>
        <Skeleton variant="text" width={100} />
        <div css={buttonWrap}>
          <Skeleton
            variant="rectangular"
            width={88}
            height={34}
            sx={{ borderRadius: '5px' }}
          />
        </div>
      </div>
      <Form>
        <FormRow>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={120} />
          </FormSection>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={120} />
          </FormSection>
        </FormRow>
        <FormRow height={66}>
          <FormSection
            label={
              <>
                <Skeleton variant="text" width={80} />
                <Skeleton variant="text" width={100} />
              </>
            }
          >
            <Skeleton variant="text" width={120} />
          </FormSection>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={120} />
          </FormSection>
        </FormRow>
        <FormRow>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={120} />
          </FormSection>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={120} />
          </FormSection>
        </FormRow>
        <FormRow>
          <FormSection label={<Skeleton variant="text" width={80} />}>
            <Skeleton variant="text" width={160} />
          </FormSection>
        </FormRow>
      </Form>
    </div>
  );
};

export default PartnerDetailInfoSkeleton;

const buttonWrap = css`
  display: flex;
  gap: 10px;
  button:nth-of-type(3) {
    background-color: ${palette.colorDanger};
    &:hover,
    &:active {
      background-color: ${palette.colorDanger};
    }
  }
`;
